import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../config";
import axios from "axios";
import { logAction } from '../../../services/LogAction';
import styles from "./Login.module.css";
import { config } from "../../../config";

function Login() {
    const [emailInput, setEmailInput] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const { login } = useContext(UserContext); // Usando a função login do contexto
    const navigate = useNavigate();

    const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setSuccessMessage("");

        if (!isValidEmail(emailInput)) {
            setError("Por favor, insira um email válido.");
            return;
        }

        setLoading(true);
        try {
            const userCredential = await signInWithEmailAndPassword(
                auth,
                emailInput,
                password
            );
            const user = userCredential.user;

            const response = await axios.get(
                `${config.apiBaseUrl}/Cliente/informacoes/adm/${user.email}`
            );
            const userData = response.data;

            // Ajuste para acessar as propriedades corretas
            if (userData?.administrador?.cD_CND) {
                const { cD_CND, nM_ADM, email } = userData.administrador;
                login(cD_CND, nM_ADM, email); // Chama a função do contexto
                navigate("/home-adm");
            } else {
                setError("Erro ao obter informações do usuário.");
            }
        } catch (err) {
            console.error("Erro durante o login:", err);

            if (err.code === "auth/user-not-found") {
                setError("Usuário não encontrado. Verifique suas credenciais.");
            } else if (err.code === "auth/wrong-password") {
                setError("Senha incorreta. Tente novamente.");
            } else {
                setError("Erro inesperado. Por favor, tente novamente.");
            }
        } finally {
            setLoading(false); // Certifique-se de desativar o estado de carregamento
        }
    };

    const handleForgotPassword = async () => {
        setError("");
        setSuccessMessage("");

        if (!isValidEmail(emailInput)) {
            setError("Por favor, insira um email válido.");
            return;
        }

        try {
            await sendPasswordResetEmail(auth, emailInput);
            setSuccessMessage("E-mail de redefinição de senha enviado!");
        } catch (err) {
            console.error("Erro ao enviar email de redefinição de senha:", err);
            setError("Erro ao enviar email. Verifique se o email está correto.");
        }
    };


    return (
        <div className="mainContainer">
            <div className={styles.loginContainer}>
                <div className={styles.filterContainer}>
                    <form onSubmit={handleLogin}>
                        <div className={styles.formRow}>
                            <label className={styles.label} htmlFor="email">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                className={styles.inputField}
                                value={emailInput}
                                onChange={(e) => setEmailInput(e.target.value)}
                                placeholder="Digite seu email"
                                required
                            />
                        </div>
                        <div className={styles.formRow}>
                            <label className={styles.label} htmlFor="password">
                                Senha
                            </label>
                            <input
                                type="password"
                                id="password"
                                className={styles.inputField}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Digite sua senha"
                                required
                            />
                        </div>
                        {error && <p className={styles.errorMessage}>{error}</p>}
                        {successMessage && <p className={styles.successMessage}>{successMessage}</p>} {/* Mensagem de sucesso */}
                        {loading && <p className={styles.loadingMessage}>Carregando...</p>}
                        <button type="submit" className={styles.filterButton} disabled={loading}>
                            {loading ? "Entrando..." : "Login"}
                        </button>
                        <button type="button" className={styles.forgotPasswordButton} onClick={handleForgotPassword}>
                            Esqueci minha senha
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
